import { Component, inject, ViewChild, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AvatarModule } from 'primeng/avatar';
import { Popover, PopoverModule } from 'primeng/popover';
import { TranslocoModule } from '@jsverse/transloco';
import { AuthService } from 'src/app/auth/services/auth-service/auth.service';
import { CurrentUserService } from 'src/app/shared/services/current-user.service';

@Component({
  selector: 'app-connected-user-profile',
  imports: [AvatarModule, PopoverModule, TranslocoModule],
  templateUrl: './connected-user-profile.component.html',
})
export class ConnectedUserProfileComponent implements OnInit {
  @ViewChild('op') op!: Popover;
  private router = inject(Router);
  private authService = inject(AuthService);
  private currentUserService = inject(CurrentUserService);

  // Utilisation des signals du service partagé
  currentUser = this.currentUserService.currentUser;

  ngOnInit() {
    // Charger les informations utilisateur via le service partagé
    this.currentUserService.loadCurrentUser().subscribe();
  }

  redirection = [
    {
      icon: 'pi pi-user',
      name: 'accountPannel.myAcount',
      redirect: 'home/account',
    },
    {
      icon: 'pi pi-sign-out',
      name: 'accountPannel.logOut',
      redirect: 'auth/login',
    },
  ];

  redirectTo(path: string) {
    if (path === 'auth/login') {
      this.authService.logout().subscribe({
        next: () => {
          this.router.navigate(['/auth/login']);
        },
        error: (err: Error) => {
          console.error('Erreur lors de la déconnexion', err);
        },
      });
    }
    this.op.hide();
    this.router.navigate([`${path}`]);
  }
}
